import {
  createContext,
  createRef,
  Dispatch,
  MutableRefObject,
  SetStateAction,
  useContext,
} from 'react';

import { SavedRow } from 'modules/dragAndDropEditor/types';
import noop from 'utils/noop';
import { Nullish } from 'utils/tsHelpers';

export type EditSavedRowDesignState = {
  savedRow: Nullish<SavedRow>;
  hasUnsavedSavedRowDesignChanges: boolean;
  isEditingSavedRowDesign: boolean;
  isEditingSavedRowDesignRef: MutableRefObject<Nullish<boolean>>;
  beeBuilderHTML: string | undefined;
  pageBeeBuilderMetadata: string | undefined;
  toggleSavedRowDesignEditorRef: MutableRefObject<
    Nullish<(pageBeeBuilderMetadata?: string) => void>
  >;
  setSavedRow: Dispatch<SetStateAction<Nullish<SavedRow>>>;
  setBeeBuilderHTML: Dispatch<SetStateAction<string | undefined>>;
  setPageBeeBuilderMetadata: Dispatch<SetStateAction<string | undefined>>;
  startEditSavedRowDesign: (row: SavedRow) => void;
  updateEditSavedRowDesign: (row: SavedRow) => void;
  resetEditSavedRowDesign: () => void;
  onExitSavedRowDesignEditor: () => void;
  onResetDragAndDropTemplateChanges: () => void;
  saveTemplateForSavedRow: (
    onSuccess: (data?: any) => void,
    onError: (error?: unknown) => void,
  ) => void;
};

export const DEFAULT_EDIT_SINGLE_ROW_STATE: EditSavedRowDesignState = {
  savedRow: null,
  isEditingSavedRowDesign: false,
  isEditingSavedRowDesignRef: createRef(),
  hasUnsavedSavedRowDesignChanges: false,
  beeBuilderHTML: undefined,
  pageBeeBuilderMetadata: undefined,
  setSavedRow: noop,
  setBeeBuilderHTML: noop,
  setPageBeeBuilderMetadata: noop,
  startEditSavedRowDesign: noop,
  updateEditSavedRowDesign: noop,
  resetEditSavedRowDesign: noop,
  onExitSavedRowDesignEditor: noop,
  toggleSavedRowDesignEditorRef: createRef(),
  onResetDragAndDropTemplateChanges: noop,
  saveTemplateForSavedRow: noop,
};

export const EditSavedRowDesignContext = createContext<EditSavedRowDesignState>(
  DEFAULT_EDIT_SINGLE_ROW_STATE,
);

export const useEditSavedRowDesignContext = () => useContext(EditSavedRowDesignContext);
